module.exports = __webpack_public_path__ + "static/img/ic_vs.f60d6e32.png";